<p-toast
  [key]="toastKey.domainVersioningToast"
  [life]="60000"
  [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'500ms'"
  [hideTransitionOptions]="'500ms'"
  position="top-right"
  [pt]="domainVersioningToastPT()"
>
  <ng-template
    let-message
    [pTemplate]="'headless'"
    let-closeFn="closeFn"
  >
    @if (message.severity === DomainVersioningTypeToast.changed) {
    <div class="domain-versioning-changed-toast-body">
      <div class="icon-container">
        <app-vector [src]="'assets/images/svg/domain-versioning/changed.svg'" />
      </div>

      <div class="info-container">
        <div class="details-and-close-toast">
          <div class="details">
            <p class="header">New Domain Version!</p>
            <p
              #domainName
              class="description"
              [appTruncateTooltip]="true"
              [ngbTooltip]="message?.data?.domainName"
            >
              {{ message?.data?.domainName }}
            </p>
          </div>

          <div class="close-toast-container">
            <app-base-button
              [isButtonAppear]="true"
              [disableAnimation]="true"
              [vectorOrIconPosition]="'right'"
              [vectorUrlOrIcon]="'pi pi-times'"
              [vectorUrlOrIconClass]="'close-toast'"
              [ariaLabel]="'Close'"
              (buttonClicked)="closeFn($event)"
            />
          </div>
        </div>

        <div class="view-changes-container">
          <app-base-button
            [isButtonAppear]="message?.data?.showDetailsButton"
            [disableAnimation]="true"
            [buttonLabel]="'View Changes'"
            [buttonClass]="'view-changes'"
            (buttonClicked)="message.data?.viewChangesButtonClicked()"
          />
        </div>
      </div>
    </div>
    }
  </ng-template>
</p-toast>
